import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { isPlatformAdminScreen, platformAdminHome } from './platform-admin';

@Injectable({ providedIn: 'root' })
export class PlatformAdminGuard implements CanActivateChild {
  constructor(private authService: AuthService, private router: Router) {}

  async canActivateChild(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    // The layouts sign out a session without their role, and they are created after this guard.
    await this.authService.sessionReady();
    if (!this.authService.getUser().isStaff || isPlatformAdminScreen(state.url)) return true;
    return this.router.parseUrl(platformAdminHome);
  }
}
